import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import type { DeliveryFieldPresentationType } from '@jira/polaris__domain-field/src/DeliveryFieldPresentationType.types.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { createGetFieldByKey } from './createGetFieldByKey.tsx';
import type { Props, State } from './FieldsUpdate.types.tsx';

export const updateDeliveryFieldPresentation =
	(fieldKey: FieldKey, presentation: DeliveryFieldPresentationType) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ fieldRemote, createAnalyticsEvent }: Props,
	): Promise<void> => {
		const state = getState();
		// oxlint-disable-next-line typescript/no-non-null-assertion
		const currentField = createGetFieldByKey(fieldKey)(state)!;

		fireTrackAnalytics(createAnalyticsEvent({}), 'issueFields updated', {
			updatedItems: [{ name: 'presentation' }],
			issueFieldKey: currentField.key,
			issueFieldType: currentField.type,
		});

		setState({
			fields: {
				...state.fields,
				[fieldKey]: {
					...state.fields[fieldKey],
					presentation: {
						type: presentation,
					},
				},
			},
		});

		await fieldRemote.updateFieldConfiguration({
			fieldKey,
			oldConfiguration: currentField.presentation
				? {
						// oxlint-disable-next-line typescript/consistent-type-assertions
						polarisPresentation: currentField.presentation.type as DeliveryFieldPresentationType,
					}
				: {},
			configuration: { polarisPresentation: presentation },
			type: 'updateDeliveryFieldPresentation',
		});
	};
